class ConfigBehaviour {
    fullscreenElement = null;
    fallbackImageUrl = '';

    constructor() {
        Object.seal(this);
    }
}

export default ConfigBehaviour;
